import { React, useEffect, useState, useRef, useContext } from 'react';
import { useSnackbar } from 'notistack';
import TokenService from '../../services/TokenService'
import { CustomerContext } from './CustomerContext';
import dayjs from 'dayjs';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import MapAreaSelector_Michigan from '../Charity/MapAreaSelector_Michigan'

export default function CharityDetail() {
    const customerContext = useContext(CustomerContext);

    function getActiveOrg() {
        if (customerContext == null) {
            return null;
        }
        if (customerContext.customer == null) {
            return null;
        }
        if (customerContext.customer.Donation_Configurations == null) {
            return null;
        }

        for (let i = 0; i < customerContext.customer.Donation_Configurations.length; i++) {
            if (customerContext.customer.Donation_Configurations[i].Status == 'Active') {
                return customerContext.customer.Donation_Configurations[i];
            }
        }

        return null;
    }

    function formatDateString(dateStr) {
        return dayjs(dateStr).format('MMM D, YYYY');
    }

    let activeCharity = getActiveOrg();

    return (<div componentname='CharityDetail'>
        {activeCharity == null ?
            <div>No active Fundraisers/Charity</div>
            :
            <div style={{textAlign:'left'} }>
                <div style={{ fontSize: '14pt', fontWeight: 'bold' }}>{activeCharity.CompanyType }</div>
                <div style={{ marginTop: '15px', borderBottom: '1px solid #efefef', fontWeight: 'bold' }}>
                    Title
                </div>
                <div>
                    {activeCharity.DonationTitle}
                </div>

                {activeCharity.CompanyType == 'Fundraiser' ?
                    <>
                        <div style={{ marginTop: '15px', borderBottom: '1px solid #efefef', fontWeight:'bold' }}>
                            Who/What is the fundraiser is for
                        </div>
                        <div>
                            {activeCharity.DonationTitle}
                        </div>
                    </>
                    :
                    null}

                <div style={{ marginTop: '15px', borderBottom: '1px solid #efefef', fontWeight: 'bold' }}>
                    Short Description
                </div>
                <div>
                    {activeCharity.CompanyDescription}
                </div>

                <div style={{ marginTop: '15px', borderBottom: '1px solid #efefef', fontWeight: 'bold' }}>
                    Website
                </div>
                <div>
                    {activeCharity.Website == '' ? 'none' : activeCharity.Website}
                </div>

                {activeCharity.CompanyType == 'Fundraiser' ?
                    <>
                        <div style={{ marginTop: '15px', borderBottom: '1px solid #efefef', fontWeight: 'bold' }}>
                            Dates
                        </div>
                        <div>
                            {formatDateString(activeCharity.StartDate.Data)} through {formatDateString(activeCharity.EndDate.Data)}
                        </div>
                    </>
                    :
                    null}

                {activeCharity.CompanyType == 'Fundraiser' && activeCharity.Images.length > 0 ?
                    <>
                        {activeCharity.Images.map((img, idx) => {
                            return <div key={'charityImage_' + idx}>
                                <img src={img.ImagePath} style={{ width: '80%', maxWidth: '330px' }} />
                            </div>
                        })}
                    </>
                    :
                    null}

                <div style={{ marginTop: '15px', borderTop: '3px solid var(--sipzee-gray-2)', borderBottom: '3px solid var(--sipzee-gray-2)', backgroundColor:'var(--sipzee-gray-3)' }}>
                    The below items are not visible to customers:
                </div>

                <div style={{ marginTop: '15px', borderBottom: '1px solid #efefef', fontWeight: 'bold' }}>
                    Email
                </div>
                <div>
                    {activeCharity.CompanyEmail}
                </div>

                <div style={{ marginTop: '15px', borderBottom: '1px solid #efefef', fontWeight: 'bold' }}>
                    Payee Name
                </div>
                <div>
                    {activeCharity.PayeeName}
                </div>


                <div style={{ marginTop: '15px', borderBottom: '1px solid #efefef', fontWeight: 'bold' }}>
                    Payment Method
                </div>
                <div>
                    {activeCharity.PaymentMethod}
                </div>

                {activeCharity.PaymentMethod == 'MAILED CHECK' ?
                    <>
                        <div style={{ marginTop: '15px', borderBottom: '1px solid #efefef', fontWeight: 'bold' }}>
                           Mailing Address
                        </div>
                        <div>
                            {activeCharity.CompanyAddress}
                            {activeCharity.CompanyAddress2 == '' ? null : <div> {activeCharity.CompanyAddress2}</div>}
                            <div>
                                {activeCharity.CompanyCity}, {activeCharity.CompanyState} {activeCharity.CompanyZipcode}
                            </div>
                        </div>
                    </>
                    : null
                }

                <div style={{ marginTop: '15px', borderBottom: '1px solid #efefef', fontWeight: 'bold' }}>
                    Area that is most local to your fundraiser.
                </div>
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <MapAreaSelector_Michigan lat={activeCharity.CentroidLatitude} lng={activeCharity.CentroidLongitude} onChange={(selected) => setCentroid(selected)} />
                </div>
            </div>
        }
    </div>)
}